export const SORT_DOWN          = "fa fa-caret-down";
export const SORT_UP            = "fa fa-caret-up";
export const SEARCH_ICON        = "fa fa-search";
export const ANGLE_LEFT         = "fa fa-angle-left";
export const ANGLE_RIGHT         = "fa fa-angle-right";
export const ANGLE_DOUBLE_LEFT  = "fa fa-angle-double-left";
export const ANGLE_DOUBLE_RIGHT = "fa fa-angle-double-right";
export const FILTER             = "fa fa-filter";
export const CLOSE              = "fa fa-times";